import {CartSuccessModal} from '@udemy-v2/react-cart-success-modal';
import {withPriceEventTrackingContext} from '@/features/course-landing-page/events/with-price-event-tracking-context';

/**
 * CartSuccessModal wrapped with price event tracking context.
 * This ensures all pricing events triggered within the modal have the 'cartSuccessModal' context.
 */
export const ClpCartSuccessModal = withPriceEventTrackingContext(CartSuccessModal, {
    context: 'cartSuccessModal',
});
